import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type BaseAppState, type EntityRef, Status } from "@client/types";
import { type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type MemberDownloads } from "./types";

export enum Actions {
  InitBegin = "MEMBER_DOWNLOADS_INIT_BEGIN",
  InitFailure = "MEMBER_DOWNLOADS_INIT_FAILURE",
  InitSuccess = "MEMBER_DOWNLOADS_INIT_SUCCESS"
}

export type InitBeginActionData = EntityRef;
export interface InitSuccessActionData {
  items: MemberDownloads.Item[];
}
export const _init = initAction<
  BaseAppState,
  InitBeginActionData,
  MemberDownloads.Api.InitResponse,
  InitSuccessActionData
>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: BaseAppState, dispatch: any, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.init(apiInfo);
  }
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);
  if (localState.status === Status.None) {
    dispatch(_init(args));
  }
};
